import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M17.58,13.29a4.83,4.83,0,0,1,1.94-3.87.5.5,0,0,0,.07-.72A5.12,5.12,0,0,0,16,7h0c-1.69-.17-3.3,1-4.16,1S9.58,7,8.18,7A5.33,5.33,0,0,0,3.67,9.76c-1.92,3.34-.49,8.28,1.38,11,.91,1.33,2,2.81,3.44,2.76s1.9-.89,3.57-.89,2.14.89,3.6.86S18.08,22.12,19,20.8a12.5,12.5,0,0,0,1.37-2.68.51.51,0,0,0-.24-.61A4.75,4.75,0,0,1,17.58,13.29Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M15,4.17a5.23,5.23,0,0,0,1.22-3.09.52.52,0,0,0-.18-.4.5.5,0,0,0-.42-.11,5.4,5.4,0,0,0-2.81,1.67,5,5,0,0,0-1.25,3.05.51.51,0,0,0,.16.37.5.5,0,0,0,.39.14A4.54,4.54,0,0,0,15,4.17Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }